// Module
var code = "<abx-asset-list class=\"flat\" abx-building=\"vm.building\" abx-models=\"vm.assets\" abx-fetch=\"vm.fetchAssets(skip, limit)\" abx-fetch-all=\"vm.fetchAllAssets(limit)\" abx-create-options=\"vm.createOptions\"> </abx-asset-list> ";
// Exports
module.exports = code;